import { useMemo } from "react";
import { useTable } from "react-table";
import {
  defaultDateDisplay,
  formatCurrency,
  truncateString,
} from "../../../helpers";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { pathConstants } from "../../../routes/pathContants";

const RecentTransactionTableLogic = ({ mostRecentTransaction }) => {
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "created_at",
        Cell: ({ cell: { value } }) => defaultDateDisplay(value),
      },
      {
        Header: "",
        accessor: "payer",
        Cell: ({ cell: { value, row } }) => (
          <Link
            to={pathConstants.PAYMENT_TRANSACTIONS_DETAILS({
              id: row?.original["id"],
            })}
            className="purple--text"
          >
            {truncateString(value || "", 12)}
          </Link>
        ),
      },
      {
        Header: "",
        accessor: "amount",
        Cell: ({ cell: { value } }) =>
          formatCurrency({ value: value, currencyCode: currency_code }),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: mostRecentTransaction });

  return {
    data: mostRecentTransaction,
    instance,
  };
};

export default RecentTransactionTableLogic;
